const scriptsQueue = [];
export const loadScriptWhenIntersecting = (selector, scriptSource, threshold = 0) => {
	const loadScript = (src) => {
		// ! Only continue if script wasn't already loaded previously
		if (!scriptsQueue.includes(src)) {
			const scriptTag = document.createElement('script');
			scriptTag.src = src;
			document.querySelector('body').appendChild(scriptTag);
			scriptsQueue.push(src);
		}
	};

	const elements = document.querySelectorAll(selector);
	if (elements.length) {
		// * Initialize IntersectionObserver
		const observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (Array.isArray(scriptSource)) {
							scriptSource.forEach((src) => loadScript(src));
						} else {
							loadScript(scriptSource);
						}

						// ! Disconnect observer to avoid loading the script again and again when another element is intersecting
						observer.disconnect();

						// Remove data attribute since we don't need it any longer
						elements.forEach((el) => el.removeAttribute('data-script-dependencies'));
					}
				});
			},
			{
				threshold: threshold,
			},
		);

		// * Observe elements
		elements.forEach((el) => observer.observe(el));
	}
};
